"use strict";

class PresenterOverviewCtrl {

    constructor($rootScope, $http, $timeout, $state, Presenter, $mdDialog, $mdToast, $filter, itemFilters, filterMap, paginationService) {

        // Dependencies
        this.$http = $http;
        this.$timeout = $timeout;
        this.$state = $state;
        this._Presenter = Presenter;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;
        this.paginationService = paginationService;

        // Controller vars
        this.$filter = $filter;
        this.itemFilters = itemFilters;
        this.filterMap = filterMap.userFilters;
        this.loaded = false;

        // Paginator
        this.pagination = {
            current: 1
        };

        // Watchers
        $rootScope.checkActive = (presenter) => {
            return presenter.id == $state.params.id;
        };

        // Fetch the overview items
        if ($state.params.id) {
            $http.get('/presenters/findpage/' + $state.params.id).then((response) => {
                this.fetch(response.data);
                this.pagination.current = response.data;
            });
        } else {
            this.fetch(1);
        }
    }


    fetch(pageNumber) {

        let filters = [];
        this.filterMap.map((filter) => {

            if (filter.enabled) {
                filters.push(filter.id);
            }
        });

        this.loaded = false;
        this.$http.get('/presenters_overview/?page=' + (pageNumber || 1) + '&filters=' + filters)
            .then((response) => {
                this.presenters = response.data.data;
                this.totalResults = response.data.total;
                this.resultPerPage = response.data.per_page;
                this.$timeout(() => {
                    this.loaded = true;
                });
            });

        this.$http.get('/modeltypes_options/presenter')
            .then((response) => {
                this.presenter_options = response.data;
            });
    }


    destroy(id, name, ev) {

        ev.stopPropagation();
        let pageN = this.paginationService.getCurrentPage('__default');

        this.$mdDialog.show({

            controller: 'ConfirmDialogCtrl',
            templateUrl: "confirmDialog.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true
        }).then(() => {

            this.loaded = false;
            this._Presenter.delete({id: id}, () => {
                this.fetch(pageN);
                this.$state.go('presenters');
            });

            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.delete?object=presenter&title=' + name, //@trans('labels.presenter')
                hideDelay: 3000,
                position: ('top right')
            });
        });
    }


    updateFilters() {

        let filters = [];
        this.filterMap.map((filter) => {

            if (!filter.enabled) {
                filters.push(filter.id);
            }
        });
        this.$http.post('/userfilters/presenter', {
            presenter_filter: filters
        }).then(() => {
            this.fetch(1);
        });
    }
}

PresenterOverviewCtrl.$inject = ['$rootScope', '$http', '$timeout', '$state', 'Presenter', '$mdDialog', '$mdToast', '$filter', 'itemFilters', 'filterMap', 'paginationService'];

module.exports = PresenterOverviewCtrl;
